<script setup>

const props = defineProps({
    session: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['close']);

const closeModal = () => {
    emit('close');
};
</script>

<template>
    <div>
        <h2>Unable to reserve a seat</h2>
        <p class="modal-copy">
            HubSpot employees cannot reserve seats for limited-capacity sessions. This ensures our customers and paid
            attendees
            get seats in rooms for breakout content.
        </p>
        <div class="modal-action-buttons">
            <ProjectButtonSecondary type="submit" @click="closeModal" :filledIn="true">Close</ProjectButtonSecondary>
        </div>
    </div>
</template>
